import { FilterList } from '@mui/icons-material';
import { Autocomplete, styled, TableCell, TableContainer, TableHead, TextField } from '@mui/material';

const StyledRoot = styled('div')(() => ({
  width: '100%',
}));

const StyledAutocomplete = styled(Autocomplete)(() => ({
  margin: '1rem 0',
  maxHeight: 'calc(50vh)',
  padding: '0',
}));

const StyledAutocompleteInput = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
  },
}));

const StyledFilterList = styled(FilterList)(({ theme }) => ({
  marginRight: theme.spacing(-3.5),
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  margin: '1rem 0',
  maxHeight: 'calc(50vh)',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderLeft: `1px solid ${theme.palette.grey[200]}`,
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: '#ffff',
  border: `1px solid ${theme.palette.grey[200]}`,
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  marginRight: '0.625rem',
  textTransform: 'uppercase',
  fontSize: '16px',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export {
  StyledAutocomplete, StyledAutocompleteInput, StyledFilterList, StyledRoot, StyledTableCell, StyledTableContainer, StyledTableHead
};

